import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL, scrollToId } from "@/data/content";

const LINKS = [
  { id: "home", label: "Home", testid: "nav-link-home" },
  { id: "servizi", label: "Servizi", testid: "nav-link-servizi" },
  { id: "metodo", label: "Metodo", testid: "nav-link-metodo" },
  { id: "chi-siamo", label: "Chi Siamo", testid: "nav-link-chi-siamo" },
  { id: "contatti", label: "Contatti", testid: "nav-link-contatti" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-slate-100 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex h-[72px] items-center justify-between">
          <button
            data-testid="navbar-logo"
            onClick={() => go("home")}
            className="flex items-center"
            aria-label="Clario — torna all'inizio"
          >
            <img src={LOGO_URL} alt="Clario — Cleaner Solution" className="h-14 w-auto" />
          </button>

          <nav className="hidden lg:flex items-center gap-8">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={l.testid}
                onClick={() => go(l.id)}
                className="text-sm font-semibold text-slate-600 transition-colors duration-200 hover:text-[#00B36B]"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <button
              data-testid="nav-cta-quote-button"
              onClick={() => go("contatti")}
              className="rounded-full bg-[#00B36B] px-5 py-2.5 text-sm font-bold text-white shadow-[0_8px_24px_rgba(0,179,107,0.3)] transition-all duration-300 hover:bg-[#009E5E] hover:shadow-[0_10px_30px_rgba(0,179,107,0.4)] hover:-translate-y-0.5"
            >
              Preventivo Rapido
            </button>
          </div>

          <button
            data-testid="nav-mobile-menu-button"
            className="lg:hidden rounded-full p-2 text-slate-700"
            onClick={() => setOpen(!open)}
            aria-label="Apri menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white/95 backdrop-blur-md">
          <div className="flex flex-col px-5 py-4 gap-1">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`${l.testid}-mobile`}
                onClick={() => go(l.id)}
                className="rounded-xl px-4 py-3 text-left text-base font-semibold text-slate-700 transition-colors hover:bg-[#E8F8F0] hover:text-[#00B36B]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-cta-quote-button-mobile"
              onClick={() => go("contatti")}
              className="mt-2 rounded-full bg-[#00B36B] px-5 py-3 text-sm font-bold text-white"
            >
              Preventivo Rapido
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
